// src/components/KioskLockOverlay.jsx
//
// Schermata di blocco della modalità kiosk.
//
// Compare ogni volta che il dispositivo perde il fullscreen (uscita accidentale
// dalla schermata, riavvio del tablet, notifica di sistema, schermo riacceso).
// Copre completamente l'interfaccia di timbratura: finché il kiosk non è
// bloccato correttamente nessuno può timbrare da un dispositivo "aperto".
//
// Un tocco ripristina il fullscreen. I browser richiedono un gesto dell'utente
// per entrare in fullscreen, quindi questo overlay non è solo un avviso: è
// l'unico modo legale per far rientrare il tablet a schermo intero dopo un
// riavvio o un reload.
//
// L'angolo in alto a sinistra resta riservato alla sequenza dei 5 tap che apre
// l'uscita d'emergenza, altrimenti l'overlay chiuderebbe fuori anche l'admin.

import React from 'react';
import './kioskLockOverlay.css';

const EMERGENCY_CORNER_SIZE = 100;

const KioskLockOverlay = ({ visible, deviceName, onUnlock, onCornerTap }) => {
  if (!visible) return null;

  const handleActivate = (e) => {
    const x = e.clientX ?? e.touches?.[0]?.clientX ?? 0;
    const y = e.clientY ?? e.touches?.[0]?.clientY ?? 0;

    // Angolo d'emergenza: lascia passare il tap all'handler dell'admin
    // senza tentare il fullscreen, così la sequenza dei 5 tap resta usabile.
    if (x <= EMERGENCY_CORNER_SIZE && y <= EMERGENCY_CORNER_SIZE) {
      if (onCornerTap) onCornerTap(e);
      return;
    }

    if (onUnlock) onUnlock();
  };

  return (
    <div
      className="kiosk-lock-overlay"
      onClick={handleActivate}
      role="button"
      tabIndex={0}
      aria-label="Schermo kiosk bloccato, tocca per riprendere"
    >
      <div className="kiosk-lock-content">
        <div className="kiosk-lock-icon">🔒</div>
        <h1 className="kiosk-lock-title">SCHERMO BLOCCATO</h1>
        <p className="kiosk-lock-subtitle">Tocca lo schermo per riprendere le timbrature</p>

        <div className="kiosk-lock-pulse">
          <span className="kiosk-lock-hand">👆</span>
        </div>

        {deviceName && (
          <div className="kiosk-lock-device">📱 {deviceName}</div>
        )}

        <p className="kiosk-lock-hint">
          Se questa schermata compare spesso, verifica che il "Blocco su schermo"
          di Android sia attivo sul dispositivo.
        </p>
      </div>
    </div>
  );
};

export default KioskLockOverlay;
